import axios from 'axios';
import { paths } from '../config/app-config';

/**
 * An axios instance to intercept request to include authorization token
 */
const axiosInstance = axios.create();
axiosInstance.interceptors.request.use(async function(config) {
   const tokenResponse = await axios.get(paths.authToken)
        .catch(error => {
            console.error('[AUTH] Error in fetch access token: ', error);
        });
   if (tokenResponse.status === 200) {
    config.headers.Authorization = `Bearer ${tokenResponse.data.access_token}`;
   }

   return config;
});

export default axiosInstance;
    